<template>
    <v-row class="ma-0 pa-0" align="center" justify="center">
      <v-col cols="12" class="chart_style ma-0 pa-0">
        <v-chart :id="chart_id" :ref="chart_ref" class="chart" :key="chart_key" :option="option" autoresize></v-chart>
      </v-col>
    </v-row>
  </template>
  
  <script>
  import VChart, { THEME_KEY } from "vue-echarts";
  import "echarts";
  import { use } from "echarts/core";
  import { CanvasRenderer } from "echarts/renderers";
  import { TitleComponent, TooltipComponent, LegendComponent } from "echarts/components";
  // import cpalette from "@/configs/ChartColors/get_color_palette";
  
  use([CanvasRenderer, TitleComponent, TooltipComponent, LegendComponent]);
  export default {
    name: "ReachComp",
    props: ["chart_title", "chart_data", "chart_id", "chart_ref", "chart_key", "color_palette", "frequency_axis_bottom"],
    components: {
      VChart,
    },
    provide: {
      [THEME_KEY]: "light",
    },
    computed: {
      option: function () {
        const dataset = this.chart_data || {};

        if (
          Object.keys(dataset).length === 0 ||
          !Array.isArray(dataset["lbls"]) ||
          dataset["lbls"].length === 0
        ) {
          return {};
        }

        return {
            title: {
                text: this.chart_title,
                fontFamily: "Poppins",
                left: 'center',
            },
            color: [
                '#2A9DBF', '#4EC5C1'
            ],
            legend: {
                data: ['Reach', 'Frequency'],
                top: '5%',
                left: 'center',
                textStyle: {
                    fontFamily: "Poppins",
                    fontSize: 12
                }
            },
            grid: {
                top: '13%',
                left: '3%',
                right: "3%",
                bottom: "4%",
                containLabel: true,
            },
            xAxis: [
                {
                    type: 'value',
                    position: this.frequency_axis_bottom ? 'top' : 'bottom',
                    axisLine: { show: true },
                    axisLabel: { 
                        fontSize: 12,
                        fontFamily: "Poppins",
                        formatter: function (value) {
                            return Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(value);
                        },
                    },
                    name: 'Unique Reach',
                    nameLocation: 'middle',
                    nameGap: 25,
                    nameTextStyle: {
                        fontSize: 14,
                        fontFamily: "Poppins",
                        fontWeight: 'bold'
                    }
                },
                {
                    type: 'value',
                    position: this.frequency_axis_bottom ? 'bottom' : 'top',
                    axisLine: { show: true },
                    axisLabel: { 
                        fontSize: 12,
                        fontFamily: "Poppins",
                        formatter: '{value}' 
                    },
                    name: 'Frequency',
                    nameLocation: 'middle',
                    nameGap: 25,
                    nameTextStyle: {
                        fontSize: 14,
                        fontFamily: "Poppins",
                        fontWeight: 'bold'
                    }
                }
            ],
            yAxis: {
                type: 'category',
                data: dataset['lbls'],
                axisLabel: {
                    fontSize: 12,
                    fontFamily: "Poppins",
                    rotate: 0, // rotate to fit more labels
                    interval: 0, // force all labels to display
                }
            },
            tooltip: {
                order: 'valueAsc',
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: function (params) {
                    if (!params || !params.length) {
                        return '';
                    }

                    const dataIndex = params[0].dataIndex;
                    const title = dataset['lbls'][dataIndex] || params[0].axisValueLabel || params[0].axisValue;
                    const reachMarker = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#2A9DBF;"></span>`;
                    const frequencyMarker = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#4EC5C1;"></span>`;
                    const reachValue = dataset['rch'][dataIndex];
                    const frequencyValue = dataset['frq'][dataIndex];

                    const body = [
                        `${reachMarker}Reach: ${Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(reachValue)}`,
                        `${frequencyMarker}Frequency: ${Number(frequencyValue).toFixed(2)}`
                    ].join('<br/>');

                    return `<strong>${title}</strong><br/>${body}`;
                }
            },
            series: [
                {
                    name: 'Reach',
                    type: 'bar',
                    xAxisIndex: 0,
                    data: dataset['rch']
                },
                {
                    name: 'Frequency',
                    type: 'bar',
                    xAxisIndex: 1,
                    data: dataset['frq']
                }
            ]
        };
      },
    },
    methods: {
    },
  };
  </script>
  
  <style scoped>
  .chart_title {
    font-family: "Poppins" !important;
    font-size: 10pt !important;
    line-height: 40px;
  
    display: block;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .chart_style {
    height: 60vh;
    font-family: "Poppins" !important;
  }
  </style>
  
